import React from 'react';

const Chip = ({
  type = 'default',
  size = 'sm',
  children,
  className = '', // Add className prop with a default value
  ...rest // Capture any other props
}) => {
  return (
    <span
      className={`msync-chip msync-chip--theme-${type} msync-chip--size-${size} ${className}`} // Apply className
      {...rest} // Pass through any remaining props
    >
      {children}
    </span>
  );
};

export default Chip;
